module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__chile_Min.e5f7d5b9.svg";